module.exports = __webpack_public_path__ + "aa8725a5771cf6335382c5cc0e5f49c5.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/DO.svg
// module id = /WVm
// module chunks = 0